<template>
  <v-row no-gutters>
    <v-col>
      <v-row no-gutters class="wrapper px-3" :class="{ 'print-wrapper': isQuickPrint }">
        <v-col cols="auto" :class="{ 'no-print': isQuickPrint }">
          <v-row no-gutters>
            <the-navbar-tools-panel-items :items="filteredTools" @coordinates="turnOffCoordinatesInteraction">
              <template #measurements="data">
                <the-navbar-top-panel-menu
                  :attach="true"
                  :has-default-activator="false"
                  v-bind="{ ...data, tools: measurementTools }"
                  :path="data.name"
                >
                  <template #menu.activator="{on: onMenu}">
                    <v-btn :class="{ background: data.isActive }" icon small :disabled="data.disabled">
                      <v-icon v-if="data.isActive" @click="measurementsClick" color="link" size="19" class="background">
                        mdi-cancel
                      </v-icon>
                      <v-icon
                        v-else
                        color="rgba(0,0,0, 0.7)"
                        size="19"
                        v-on="{ ...onMenu, ...data.on }"
                        v-text="data.icon"
                      >
                      </v-icon>
                    </v-btn>
                  </template>
                </the-navbar-top-panel-menu>
              </template>
              <template #addTask="data">
                <the-navbar-top-panel-menu
                  :attach="true"
                  :has-default-activator="false"
                  v-bind="{ ...data, tools: taskTools }"
                  :path="data.name"
                >
                  <template #menu="{on: onMenu}">
                    <v-icon color="rgba(0,0,0, 0.7)" size="19" v-on="{ ...onMenu, ...data.on }" v-text="data.icon">
                    </v-icon>
                  </template>
                </the-navbar-top-panel-menu>
              </template>
              <template #searchParcel="data" v-if="parcelsProvider === 'system'">
                <the-navbar-tools-panel-search v-bind="{ ...data, layer: 'parcels' }" v-on="data.on">
                </the-navbar-tools-panel-search>
              </template>
              <template #searchAddress="data">
                <the-navbar-tools-panel-search v-bind="{ ...data, layer: 'address_points' }" v-on="data.on">
                </the-navbar-tools-panel-search>
              </template>
              <template #zdmStreets="data">
                <the-navbar-tools-zdm-streets v-bind="data" v-on="data.on" class="pt-1" />
              </template>
              <template #reverseGeocoder="data">
                <the-navbar-tools-panel-reverse-geocoder
                  v-bind="data"
                  v-on="data.on"
                ></the-navbar-tools-panel-reverse-geocoder>
              </template>
            </the-navbar-tools-panel-items>
          </v-row>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto">
          <the-navbar-tools-panel-map-info />
        </v-col>
      </v-row>

      <main-large-dialog
        :is-visible.sync="isMobileVisible"
        v-if="isDialogLoaded"
        :title="$i18n.t('dialog.title.mobile')"
        disagree-text="dialog.disagreeClose"
        :is-agree-visible="false"
      >
        <template #body>
          <div class="pa-6">
            <v-subheader
              class="font--text text-subtitle-1 font-weight-bold text-center"
              v-text="$i18n.t('dialog.body.scanQr')"
              style="height: auto"
            >
            </v-subheader>
            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap text-left text-body-2">
                    1.
                    <i18n path="dialog.body.mobile_1" tag="span">
                      <template #link>
                        <a target="_blank" :href="url">link</a>
                      </template>
                    </i18n>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap text-left  text-body-2">
                    2.
                    <i18n path="dialog.body.mobile_2" tag="span"> </i18n>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <qrcode-vue :value="url" size="200" level="H"></qrcode-vue>
          </div>
        </template>
      </main-large-dialog>
      <main-large-dialog
        :is-visible.sync="isQgisVisible"
        v-if="isDialogLoaded"
        disagree-text="dialog.disagreeClose"
        :is-agree-visible="false"
        :title="$i18n.t('dialog.title.qgis')"
      >
        <template #body>
          <div class="pa-6">
            <v-subheader
              class="font--text text-subtitle-1 font-weight-bold text-center"
              v-text="$i18n.t('dialog.body.howToInstallQgis')"
              style="height: auto"
            >
            </v-subheader>
            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap text-left text-body-2">
                    1.
                    <i18n path="dialog.body.qgis_1" tag="span">
                      <template #link>
                        <a target="_blank" :href="repositoryUrl">{{ repositoryUrl }}</a>
                      </template>
                    </i18n>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap text-left  text-body-2">
                    2.
                    <i18n path="dialog.body.qgis_2" tag="span">
                      <template #link>
                        <a target="_blank" :href="knowledgeBaseUrl">{{ $i18n.t('dialog.body.qgis_2_link') }}</a>
                      </template>
                    </i18n>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </template>
      </main-large-dialog>
    </v-col>
  </v-row>
</template>

<script>
import { sync, get } from 'vuex-pathify';

import QrcodeVue from 'qrcode.vue';

import tools from '@/mixins/tools';

import TheNavbarTopPanelMenu from '@/components/TheNavbarTopPanelMenu';
import TheNavbarToolsPanelItems from '@/components/TheNavbarToolsPanelItems';
import TheNavbarToolsPanelMapInfo from '@/components/TheNavbarToolsPanelMapInfo';
import TheNavbarToolsPanelSearch from '@/components/TheNavbarToolsPanelSearch';
import TheNavbarToolsZdmStreets from '@/components/TheNavbarToolsZdmStreets';
import TheNavbarToolsPanelReverseGeocoder from '@/components/TheNavbarToolsPanelReverseGeocoder';

export default {
  name: 'TheNavbarToolsPanel',
  mixins: [tools],
  components: {
    TheNavbarTopPanelMenu,
    TheNavbarToolsPanelItems,
    TheNavbarToolsPanelMapInfo,
    QrcodeVue,
    TheNavbarToolsPanelSearch,
    TheNavbarToolsZdmStreets,
    TheNavbarToolsPanelReverseGeocoder,
    MainLargeDialog: () => import('@/components/MainLargeDialog'),
  },
  data: () => ({
    repositoryUrl: `${process.env.VUE_APP_API_URL}/qgis_plugins/repository`,
    knowledgeBaseUrl: 'https://aquagis.pl/baza-wiedzy/qgis/jak-zainstalowac-wtyczke-aquagis/',
    app_kind: `${process.env.VUE_APP_APP_KIND}`,
    isDialogLoaded: false,
    isMobileVisible: false,
    isQgisVisible: false,
    isMeasureActive: false,
    measurementTools: [
      {
        name: 'measurementArea',
        hasDivider: false,
        hasCustomAction: true,
        icon: 'mdi-vector-square',
        isAuthorized: false,
      },
      {
        name: 'measurementLength',
        hasDivider: false,
        hasCustomAction: true,
        icon: 'mdi-vector-line',
      },
    ],
    taskTools: [
      {
        name: 'singleTask',
        isToolWorking: false,
      },
      {
        name: 'multiTasks',
        isToolWorking: false,
      },
    ],
  }),
  computed: {
    url() {
      return `${process.env.VUE_APP_API_URL}/mobile_app/${this.app_kind}/latest`;
    },
    documentsLayerId: get('admin/modulesMapping@documentation.documentation_layer_id'),
    isMeasurementsToolActive: sync('tools/toolStatus@isMeasurementsToolActive'),
    isCoordinatesToolActive: sync('tools/toolStatus@isCoordinatesToolActive'),
    isFetched: get('sidebar/isFetched'),
    parcelsProvider: get('admin/settingsValues@parcels_provider'),
    isQuickPrint: get('tools/toolStatus@isQuickPrintToolActive'),
    activeTool: get('tools/activeTool'),
  },
  methods: {
    measurementsClick() {
      if (this.isMeasurementsToolActive) {
        this.$root.$emit(`${this.activeTool}-action`, false);
      }
    },
    turnOffCoordinatesInteraction() {
      if (this.isCoordinatesToolActive) {
        this.$root.$emit('turnOffCoordinatesInteraction');
      }
    },
  },
  mounted() {
    this.$root.$off('MOBILE-action');
    this.$root.$off('QGIS_PLUGIN-action');
    this.$root.$off('addDocument-action');
    this.$root.$on('MOBILE-action', () => {
      this.isDialogLoaded = true;
      this.isMobileVisible = true;
    });
    this.$root.$on('QGIS_PLUGIN-action', () => {
      this.isDialogLoaded = true;
      this.isQgisVisible = true;
    });
    this.$root.$on('addDocument-action', () => {
      if (this.documentsLayerId) {
        this.$router.push({
          name: 'layerFeature',
          params: { lid: this.documentsLayerId, fid: 'new' },
        });
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  @include border(bottom);
  padding: 7px 0;
}
.main-large-dialog {
  .v-list-item__title {
    line-height: 30px !important;
  }
}
.background {
  background-color: #e8f0fe !important;
  color: map-get($colors, 'link') !important;
  border-radius: 2px;
}
</style>
